import Head from "next/head";
import Image from "next/image";
import styles from "../../styles/Home.module.css";
import {
  theme,
  ThemeProvider,
  CSSReset,
  Container,
  Box,
  Text,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  Link,
  Button,
  Collapse,
  Checkbox,
  Stack,
  Textarea,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Spinner,
  Center,
  Grid,
  GridItem,
  SimpleGrid,
  Flex,
  Spacer,
  Wrap,
  WrapItem,
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
  Heading,
  ButtonGroup,
} from "@chakra-ui/react";

import BaseLayout from "../../components/base_layout";

export default function Home() {
  return (
    <BaseLayout>
      <Center bg="#EDF7FF">
        <Center
          w="1000px"
          h="320px"
          color="white"
          backgroundImage="URL(/images/affiliate_bg.png)"
        >
          <Box
            maxW="32rem"
            textAlign="center"
            color="#424242"
            letterSpacing="-1px"
            className="affiliate_banner"
          >
            <Text fontSize="xl" marginBottom="2">
              전자부품 온라인 구매 플랫폼 판다파츠
            </Text>
            <Heading mb={4}>
              판다파츠 제휴 파트너에<br></br>가입하세요!
            </Heading>
            <Link href="../board/register">
              <Button
                size="lg"
                colorScheme="blue"
                mt="10px"
                letterSpacing="-2px"
                width="200px"
                height="48px"
              >
                파트너 신청
              </Button>
            </Link>
            <Box className="affiliate_bg"></Box>
          </Box>
        </Center>
      </Center>
      <Heading as="h2" size="xl" textAlign="center" mt="20" paddingBottom="5">
        절차안내
      </Heading>
      <Text
        fontSize="2xl"
        textAlign="center"
        letterSpacing="-2px"
        color="#424242"
        className="affiliate_warning"
      >
        제휴 파트너는 유통사, 제조사 대상의<br></br>상시 할인과 적립이 되는
        멤버쉽 서비스입니다.
      </Text>

      <Center bg="" h="300px" color="white" className="affiliate_notice">
        <Flex>
          <Box className="affiliate_img" bg="">
            <img src="/images/icon_01.png"></img>
            <Center bg="" h="50px" color="black">
              <Heading as="h4" size="md" color="#424242">
                판다파츠 회원가입
              </Heading>
            </Center>
          </Box>

          <Box className="affiliate_img" bg="">
            <img src="/images/icon_02.png"></img>
            <Center bg="" h="50px" color="black">
              <Heading as="h4" size="md" color="#424242">
                제휴파트너 신청접수
              </Heading>
            </Center>
          </Box>

          <Box className="affiliate_img" bg="">
            <img src="/images/icon_03.png" textAlign="center"></img>
            <Center bg="" h="50px" color="black">
              <Heading as="h4" size="md" color="#424242">
                확인 및 승인 후 이용
              </Heading>
            </Center>
          </Box>
        </Flex>
      </Center>
    </BaseLayout>
  );
}
